const { setInitialised, useDots, useArrows } = window.BAO.Carousel.plugins

class ProductUpsells extends window.BAO.CustomElement() {
  connectedCallback () {
    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 15,
        },
        breakpoints: {
          '(min-width: 901px)': {
            slides: {
              perView: 2,
              spacing: 30,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: 3,
              spacing: 30,
            },
          },
        },
      },
      [
        setInitialised(),
        useDots(this.els?.dot?.elements),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('product-upsells')) {
  customElements.define('product-upsells', ProductUpsells)
}
